/** React/Redux imports */ import { connect } from 'react-redux';
import { buildDispatchable } from '../../../actions/_action-utilities';
/** Component imports */ import * as dictionaryValues from '../../../actions/dictionary-values';
import DictionaryHistory from './dictionary-history';
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        listHistory: (dictionaryId)=>{
            runDispatchable(()=>{
                return dispatch(dictionaryValues.listDictionaryHistory(dictionaryId));
            });
        },
        downloadDictionaryByRequestID: (requestId)=>{
            runDispatchable(()=>{
                return dispatch(dictionaryValues.downloadDictionaryByRequestID({
                    requestId
                }));
            });
        }
    };
};
export default connect(()=>{}, mapDispatchToProps)(DictionaryHistory);
